import React, { PureComponent } from 'react';
import cn from 'classnames';
import { array, func, bool } from 'prop-types';
import ListItem from './ListItem';
import ListGroup from './ListGroup';
import ListFilter from './ListFilter';

class List extends PureComponent {
  static propTypes = {
    items: array.isRequired,
    onItemChange: func.isRequired,
    onSubItemsChange: func,
    onSearch: func,
    hasParent: bool,
    search: bool,
  };

  static defaultProps = {
    items: [],
    onItemChange() {},
    onSubItemsChange() {},
    onSearch() {},
    hasParent: false,
    search: false,
  };

  state = {
    open: {},
    query: '',
  };

  componentDidMount() {
    const { items, hasParent } = this.props;
    if (!hasParent) {
      const open = {};

      items.forEach((item) => {
        if (item.subParams && item.subParams.length) {
          const isOpen = this.hasCheckedChildren(item.subParams);

          open[item.id] = isOpen;
        }
      });

      this.setState((prevState) => ({
        open: {
          ...prevState.open,
          ...open,
        },
      }));
    }
  }

  hasCheckedChildren = (items) => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].checked) return true;
    }

    return false;
  };

  handleListItemChange = (id, e, hasSubItems = false) => {
    const { target } = e;
    const { parentId } = this.props;
    this.props.onItemChange(target.value, e, hasSubItems);

    if (parentId) {
      this.props.onSubItemsChange(parentId);
    }

    if (hasSubItems) {
      this.setState((prevState) => ({
        open: {
          ...prevState.open,
          [id]: target.checked,
        },
      }));
    }
  };

  handleSearch = (query) => {
    this.setState(
      () => ({ query }),
      () => {
        this.props.onSearch(query);
      },
    );
  };

  filterByQuery = (items = [], query) =>
    items.filter(({ title }) => title.toLowerCase().includes(query));

  getFilteredItems = (items = []) => {
    let { query } = this.state;

    if (query.length > 0) {
      let result = [];

      items.forEach((item) => {
        if (item.title.toLowerCase().includes(query)) {
          result.push(item);
        }

        if (item.subParams && item.subParams.length > 0) {
          result.push(...this.filterByQuery(item.subParams, query));
        }
      });

      return result;
    }

    return items;
  };

  toggle = (id) => {
    this.setState((prevState) => ({
      open: {
        ...prevState.open,
        [id]: !prevState.open[id],
      },
    }));
  };

  renderItems = () => {
    const { open } = this.state;

    const { items, name, onItemChange, onSubItemsChange, parentIndex, hasParent } = this.props;

    const filteredItems = this.getFilteredItems(items);

    return filteredItems.map((item, index) => {
      const hasSubItems = item.subParams && item.subParams.length > 0;
      const id = hasParent ? `${name}_${parentIndex}_${index}` : `${name}_${index}`;

      return !hasSubItems ? (
        <ListItem
          key={item.id}
          name={`${name}[]`}
          id={id}
          title={item.title}
          value={item.id}
          param={item.count}
          onChange={(e) => this.handleListItemChange(item.id, e)}
          checked={item.checked}
        />
      ) : (
        <ListGroup
          id={item.id}
          item={item}
          onClick={this.toggle}
          handleListItemChange={this.handleListItemChange}
          onItemChange={onItemChange}
          onSubItemsChange={onSubItemsChange}
          index={index}
          key={item.id}
          className={cn('filter-list-group', {
            collapsed: !open[item.id],
          })}
        />
      );
    });
  };

  render() {
    const { search, hasParent, children } = this.props;

    return (
      <>
        <ul className="filter-list">
          {!hasParent && search && <ListFilter tag="li" onChange={this.handleSearch} />}
          {!hasParent && children}
          {this.renderItems()}
        </ul>
      </>
    );
  }
}

export default List;
